export default __webpack_public_path__ + "static/media/pluma-mobile.44d888af.png";